import React from 'react';
import { Helmet } from 'react-helmet-async';
import Content from './38129da9a00b.jpg';
import { newsData } from '../newsData';
import NavigationButtons from '../navigationButtons';

const OtopitelnyyPeriodEnd = () => {
  const pathname = window.location.pathname;
  const currentNewsIndex = newsData.findIndex(item => pathname.includes(item.url));

  const prevNewsIndex = currentNewsIndex > 0 ? currentNewsIndex - 1 : null;
  const nextNewsIndex = currentNewsIndex < newsData.length - 1 ? currentNewsIndex + 1 : null;

  const currentNews = newsData[currentNewsIndex];

  return (
    <article>
      <Helmet defer={false}>
        <title>Об окончании отопительного периода 2023–2024 гг. | ООО УК «ВЕХА»</title>
        <meta name="description" content="Информация об окончании отопительного периода 2023–2024 годов в домах под управлением УК ВЕХА." />
      </Helmet>
    <div>
      <h2 className='news_header'>ОБ ОКОНЧАНИИ ОТОПИТЕЛЬНОГО ПЕРИОДА 2023-2024 ГГ.</h2>
      <div className='news_content'>
        <NavigationButtons prevNewsIndex={prevNewsIndex} nextNewsIndex={nextNewsIndex} />
       <p>Опубликовано {currentNews.date}</p>
        <img src={Content} width="60%" alt="Content" />
      </div>
    </div>
    </article>
  );
};

export default OtopitelnyyPeriodEnd;